import React, {Component} from 'react';

class Recipient extends Component {

    state = {
        showElement : false,
        labelValue : "Show Mapped Fields"
    }

    constructor(props) {
        super(props);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleScopeChange = this.handleScopeChange.bind(this);
        this.handleRemoveRow = this.handleRemoveRow.bind(this);
        this.handleElementNameChange = this.handleElementNameChange.bind(this)
        this.generateAccessCode = this.generateAccessCode.bind(this);
        this.handleOnChangeIsRequester= this.handleOnChangeIsRequester.bind(this);
        this.showField = this.showField.bind(this);
        this.handleOrderValue = this.handleOrderValue.bind(this)
    }
    generateAccessCode(event){
        this.props.accessCodeChange(this.props.recipient.index, event.target.value);
    }
    handleOrderValue(event){
        this.props.orderValueChange(this.props.recipient.index, event.target.value);
    }
    handleNameChange(event) {
        this.props.onNameChange(this.props.recipient.index, event.target.value);
    }

    handleEmailChange(event) {
        this.props.onEmailChange(this.props.recipient.index, event.target.value);
    }

    handleScopeChange(event) {
        this.props.onScopeChange(this.props.recipient.index, event.target.value);
    }

    handleRemoveRow(event) {
        this.props.onRemoveRow(this.props.recipient.index);
    }

    handleElementNameChange(event) {
        this.props.onElementNameChange(this.props.recipient.index,event);
    }
    handleOnChangeIsRequester(event){
        this.props.onIsRequesterChange(this.props.recipient.index,event)
    }

    showField(event){
        if(this.state.showElement === false){
            this.setState({showElement : true, labelValue : "Hide Mapped Fields"})
        }else{
            this.setState({showElement : false, labelValue : "Show Mapped Fields"})
        }
    }
    render() {
        const options = ['Signer', 'CC','Fixed Signer','Fixed CC','Requester'].map((scope) => {
            if (scope === this.props.recipient.scope) {
                return <option key={scope} value={scope} >{scope}</option>;
            } else {
                return <option key={scope} value={scope}>{scope}</option>;
            }
        });
        const options_old = ['Signer', 'CC'].map((scope) => {
            if (scope === this.props.recipient.scope) {
                return <option key={scope} value={scope} >{scope}</option>;
            } else {
                return <option key={scope} value={scope}>{scope}</option>;
            }
        });
        let _this = this;
        const draggedElements = this.props.selectedTemplateElementName ? this.props.selectedTemplateElementName.map((data, index) => {
            return <option key={index} value={data}>{data}</option>;
        }) : "";
        let st = {color:"green",fontWeight:"900"};
        if (_this.props.recipient.isRequester !== true) {
            st["display"] = "none"
        }

        if((this.props.recipient.scope===("Signer")||this.props.recipient.scope===("CC")) && this.props.recipient.role!==""){
            return (
                <React.Fragment>
                    <div className="ibox-content" style={{border:'1px solid #ddd',backgroundColor: '#eee',marginBottom:"3px", padding: "0px 5px 5px 5px"}}>
                        <div className="row show-grid" style={{margin: "5px 0"}}>
                            <div className="row" style={{marginLeft:"0px",marginRight:"0px"}}>
                                <span style={{fontWeight:900}}>{this.props.recipient.role}</span>
                                <span style={{...st}}>&nbsp;&nbsp;(The user initiating this Esignature Request)</span>
                            </div>
                            <div className="row" style={{marginLeft:"0px",marginRight:"0px"}}>
                                <div className="col-md-3" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px"}}>
                                    <input type="text"
                                           placeholder="Enter Signer Name"
                                           className="form-control namcls"
                                           value={this.props.recipient.name}
                                           onChange={this.handleNameChange} autoComplete="nope" style={{padding:"6px 3px"}}/>
                                    <span style={{color:'red'}}>{this.props.recipient.nameErrorMsg}</span>
                                </div>
                                <div className="col-md-3" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px"}}>
                                    <input type="text" name='mail'
                                           placeholder="Enter Signer Email"
                                           className="form-control mailcls"
                                           value={this.props.recipient.email}
                                           onChange={this.handleEmailChange} autoComplete="nope"/>
                                    <span style={{color:'red'}}>{this.props.recipient.emailErrorMsg}</span>
                                </div>
                                <div className="col-sm-1" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px",width:"10%"}} hidden={true}>
                                    <select className="form-control scopecls" name="scope" selected={this.props.recipient.scope} value={this.props.recipient.scope} onChange={this.handleScopeChange} >
                                        <option value="">Select Scope</option>
                                        {options}
                                    </select>
                                    <span style={{color:'red'}}>{this.props.recipient.scopeErrorMsg}</span>
                                </div>
                                {/*  <div className="col-sm-2" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px"}}>
                                <a onClick={_this.showField} style={{textDecoration:"underline",fontSize:"10px"}}>{this.state.labelValue}</a>
                                <select className="form-control elementscls" name="elements" multiple="multiple" style={{display:(this.state.showElement === true ? "block" : "none")}} selected={this.props.recipient.elements} value={this.props.recipient.elements} onChange={this.handleElementNameChange}>
                                    <option value="">Dragged Element</option>
                                    {draggedElements}
                                </select>
                                <span style={{color:'red'}}>{this.props.recipient.elementErrorMsg}</span>
                            </div>*/}
                                <div className="col-sm-1" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px",display:(this.props.recipient.enabledSigningOrder === true ? '' : 'none')}}>
                                    <button type="button" className="btn btn-white btn-sm upBtn" style={{color:'#1ab394'}} onClick={(e)=>this.props.moveUp(_this.props.recipient.index)}>
                                        <i className="fa fa-arrow-up"></i></button>
                                    &nbsp;<button type="button" className="btn btn-white btn-sm upBtn" style={{color:'#1ab394'}} onClick={(e)=>this.props.moveDown(_this.props.recipient.index)}>
                                    <i className="fa fa-arrow-down"></i></button>
                                </div>

                            </div>
                            {(_this.props.enableSigningOrder && this.props.recipient.orderValue !== null)? <div className="row" style={{marginLeft:"0px",marginRight:"0px"}}>
                                <div className="col-sm-3" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px",color:"blue"}}>
                                    Signing Order#&nbsp;{this.props.recipient.orderValue}
                                </div>
                            </div> : null}

                        </div>

                    </div>
                </React.Fragment>

            );
        }
        else if(this.props.recipient.scope===("Fixed Signer") || this.props.recipient.scope===("Fixed CC") || this.props.recipient.scope===("Requester")){
            return (
                <React.Fragment>
                    <div className="ibox-content" style={{border:'1px solid #ddd',backgroundColor: '#eee',marginBottom:"3px", padding: "0px 5px 5px 5px"}}>
                        <div className="row show-grid" style={{margin: "5px 0"}}>
                            <div className="row" style={{marginLeft:"0px",marginRight:"0px"}}>
                                <span style={{fontWeight:900}}>{this.props.recipient.scope}</span>
                                <span style={{...st}}>&nbsp;&nbsp;(The user initiating this Esignature Request)</span>
                            </div>
                            <div className="row" style={{marginLeft:"0px",marginRight:"0px"}}>
                                <div className="col-md-3" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px"}}>
                                    <input type="text"
                                           placeholder="Enter Signer Name"
                                           className="form-control namcls"
                                           value={this.props.recipient.name}
                                           onChange={this.handleNameChange} autoComplete="nope" style={{padding:"6px 3px"}}/>
                                    <span style={{color:'red'}}>{this.props.recipient.nameErrorMsg}</span>
                                </div>
                                <div className="col-md-3" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px"}}>
                                    <input type="text" name='mail'
                                           placeholder="Enter Signer Email"
                                           className="form-control mailcls"
                                           value={this.props.recipient.email}
                                           onChange={this.handleEmailChange} autoComplete="nope"/>
                                    <span style={{color:'red'}}>{this.props.recipient.emailErrorMsg}</span>
                                </div>
                                <div className="col-sm-1" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px",width:"10%"}} hidden={true}>
                                    <select className="form-control scopecls" name="scope" selected={this.props.recipient.scope} value={this.props.recipient.scope} onChange={this.handleScopeChange} >
                                        <option value="">Select Scope</option>
                                        {options}
                                    </select>
                                    <span style={{color:'red'}}>{this.props.recipient.scopeErrorMsg}</span>
                                </div>
                                {/*  <div className="col-sm-2" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px"}}>
                                <a onClick={_this.showField} style={{textDecoration:"underline",fontSize:"10px"}}>{this.state.labelValue}</a>
                                <select className="form-control elementscls" name="elements" multiple="multiple" style={{display:(this.state.showElement === true ? "block" : "none")}} selected={this.props.recipient.elements} value={this.props.recipient.elements} onChange={this.handleElementNameChange}>
                                    <option value="">Dragged Element</option>
                                    {draggedElements}
                                </select>
                                <span style={{color:'red'}}>{this.props.recipient.elementErrorMsg}</span>
                            </div>*/}
                                <div className="col-sm-1" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px",display:(this.props.recipient.enabledSigningOrder === true ? '' : 'none')}}>
                                    <button type="button" className="btn btn-white btn-sm upBtn" style={{color:'#1ab394'}} onClick={(e)=>this.props.moveUp(_this.props.recipient.index)}>
                                        <i className="fa fa-arrow-up"></i></button>
                                    &nbsp;<button type="button" className="btn btn-white btn-sm upBtn" style={{color:'#1ab394'}} onClick={(e)=>this.props.moveDown(_this.props.recipient.index)}>
                                    <i className="fa fa-arrow-down"></i></button>
                                </div>

                            </div>
                            {(_this.props.enableSigningOrder && this.props.recipient.orderValue !== null)? <div className="row" style={{marginLeft:"0px",marginRight:"0px"}}>
                                <div className="col-sm-3" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px",color:"blue"}}>
                                    Signing Order#&nbsp;{this.props.recipient.orderValue}
                                </div>
                            </div> : null}

                        </div>

                    </div>
                </React.Fragment>

            );
        }
        else{
            return (
                <React.Fragment>
                    <div className="ibox-content" style={{border:'1px solid #ddd',backgroundColor: '#eee',marginBottom:"3px", padding: "0px 5px 5px 5px"}}>
                        <div className="row show-grid" style={{margin: "5px 0"}}>
                            <div className="row" style={{marginLeft:"0px",marginRight:"0px"}}>
                                Recipient #{this.props.recipient.index+1}
                                <span style={{...st}}>&nbsp;&nbsp;(The user initiating this Esignature Request)</span>
                            </div>
                            <div className="row" style={{marginLeft:"0px",marginRight:"0px"}}>
                                <div className="col-md-3" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px"}}>
                                    <input type="text"
                                           placeholder="Enter Signer Name"
                                           className="form-control namcls"
                                           value={this.props.recipient.name}
                                           onChange={this.handleNameChange} autoComplete="nope" style={{padding:"6px 3px"}}/>
                                    <span style={{color:'red'}}>{this.props.recipient.nameErrorMsg}</span>
                                </div>
                                <div className="col-md-3" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px"}}>
                                    <input type="text" name='mail'
                                           placeholder="Enter Signer Email"
                                           className="form-control mailcls"
                                           value={this.props.recipient.email}
                                           onChange={this.handleEmailChange} autoComplete="nope"/>
                                    <span style={{color:'red'}}>{this.props.recipient.emailErrorMsg}</span>
                                </div>
                                <div className="col-sm-1" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px",width:"10%"}}>
                                    <select className="form-control scopecls" name="scope" selected={this.props.recipient.scope} value={this.props.recipient.scope} onChange={this.handleScopeChange}>
                                        <option value="">Select Scope</option>
                                        {options_old}
                                    </select>
                                    <span style={{color:'red'}}>{this.props.recipient.scopeErrorMsg}</span>
                                </div>
                                {/*  <div className="col-sm-2" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px"}}>
                                <a onClick={_this.showField} style={{textDecoration:"underline",fontSize:"10px"}}>{this.state.labelValue}</a>
                                <select className="form-control elementscls" name="elements" multiple="multiple" style={{display:(this.state.showElement === true ? "block" : "none")}} selected={this.props.recipient.elements} value={this.props.recipient.elements} onChange={this.handleElementNameChange}>
                                    <option value="">Dragged Element</option>
                                    {draggedElements}
                                </select>
                                <span style={{color:'red'}}>{this.props.recipient.elementErrorMsg}</span>
                            </div>*/}
                                <div className="col-sm-1" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px",display:(this.props.recipient.enabledSigningOrder === true ? '' : 'none')}}>
                                    <button type="button" className="btn btn-white btn-sm upBtn" style={{color:'#1ab394'}} onClick={(e)=>this.props.moveUp(_this.props.recipient.index)}>
                                        <i className="fa fa-arrow-up"></i></button>
                                    &nbsp;<button type="button" className="btn btn-white btn-sm upBtn" style={{color:'#1ab394'}} onClick={(e)=>this.props.moveDown(_this.props.recipient.index)}>
                                    <i className="fa fa-arrow-down"></i></button>
                                </div>

                            </div>
                            {(_this.props.enableSigningOrder && this.props.recipient.orderValue !== null)? <div className="row" style={{marginLeft:"0px",marginRight:"0px"}}>
                                <div className="col-sm-3" style={{border:'#eee',paddingRight: "5px",paddingLeft:"2px",paddingBottom:"0px",paddingTop:"0px",color:"blue"}}>
                                    Signing Order#&nbsp;{this.props.recipient.orderValue}
                                </div>
                            </div> : null}

                        </div>

                    </div>
                </React.Fragment>

            );
        }

    }
}

export default Recipient;



// WEBPACK FOOTER //
// ./src/components/template/Recipient.js